import * as ImportedSlideOut from "@interstate/components/SlideOut";
export const BridgeBarHeight = 35;
export interface SlideOutProps
  extends Exclude<ImportedSlideOut.SlideOutProps, "hasBridgeBar"> {
  hasBridgeBar: boolean;
}
export const SlideOut = (props: SlideOutProps) => {
  return (
    <ImportedSlideOut.SlideOut
      {...props}
      {...(props.hasBridgeBar ? { topOffset: "35px" } : {})}
    />
  );
};
